import { Modal, ModalProps } from '~/components/Modal/Modal';
import styles from '~/components/Modal/Modal.module.scss';

export { styles };

export type ConfirmProps = Omit<ModalProps, 'closeButton'>;
export const Confirm = (props: ConfirmProps) => <Modal {...props} closeButton={null} />;
